import React from 'react';
import {labels, currentResource} from '../../../util/utils';
import AdminHomePage from '../AdminHomePage';
import ManageUsers from '../ManageUsers';
import ManageAdmins from '../ManageAdmins/ManageAdmins';
import ManageProjects from '../ManageProjects/ManageProjects';

export function getAdminRoutes() {
	var adminRoutes = [
		{
			path: '/admin/manageusers',
			component: <ManageUsers />,
			moduleName: labels.manageUsers,
			iconName: 'manage-users',
			breadCrumb: [
				{
					label: labels.homeLabel,
					link: '/admin'
				},
				{
					label: labels.manageUsers,
					link: '/admin/manageusers',
					isLastCrumb: true
				}
			]
		},
		{
			path: '/admin/manageprojects',
			component: <ManageProjects />,
			moduleName: labels.manageProjectsFormatted,
			iconName: 'manage-users',
			breadCrumb: [
				{
					label: labels.homeLabel,
					link: '/admin'
				},
				{
					label: labels.manageProjectsFormatted,
					link: '/admin/manageprojects',
					isLastCrumb: true
				}
			]
		},
		{
			path: '/admin/manageprojects/:projectId?',
			component: <ManageProjects />,
			moduleName: labels.manageProjectsFormatted,
			iconName: 'manage-users',
			breadCrumb: [
				{
					label: labels.homeLabel,
					link: '/admin'
				},
				{
					label: labels.manageProjectsFormatted,
					link: '/admin/manageprojects/:projectId?',
					isLastCrumb: true
				}
			]
		},
		{
			path: '/admin/manageadmins',
			component: <ManageAdmins />,
			moduleName: labels.manageAdminsFormatted,
			iconName: 'manage-users',
			breadCrumb: [
				{
					label: labels.homeLabel,
					link: '/admin'
				},
				{
					label: labels.manageAdminsFormatted,
					link: '/admin/manageadmins',
					isLastCrumb: true
				}
			]
		},
		{
			path: '/admin',
			component: <AdminHomePage />,
			breadCrumb: []
		}
	];

	return adminRoutes;
}
